import ExperimentProviderContext from '@carvana/experiment/ExperimentProviderContext';
import { datadogRum } from '@datadog/browser-rum';
import { useContext, useEffect } from 'react';
import FinanceAndTradeContext from '~/context/srp/FinanceAndTradeContext';

const useSetDataDogContext = () => {
  const { experiments } = useContext(ExperimentProviderContext);
  const { financeInfo, tradeInfo } = useContext(FinanceAndTradeContext);

  useEffect(() => {
    const experimentsWithBucket = Object.keys(experiments).reduce(
      (accum, key) => {
        accum[key] = experiments[key].assignedBucket;

        return accum;
      },
      {}
    );

    datadogRum.setGlobalContextProperty('experiments', experimentsWithBucket);
  }, [experiments]);

  useEffect(() => {
    datadogRum.setGlobalContextProperty(
      'softpullStatus',
      financeInfo?.financingType
    );
    datadogRum.setGlobalContextProperty('tradeStatus', tradeInfo?.data.status);
  }, [financeInfo.financingType, tradeInfo?.data.status]);
};

export default useSetDataDogContext;
